import styled, { css } from 'styled-components';
import { Checkbox as ANTDCheckbox } from 'antd';
import { themeColor } from 'utils/mixins';
import { antdTokens } from 'theme/antd';

export const checkboxStyle = css<{ $readOnly?: boolean }>`
  &.ant-checkbox-wrapper,
  & .ant-checkbox-wrapper {
    --ant-color-primary: ${themeColor('darkBlue')};
    --ant-color-primary-hover: ${themeColor('darkBlue')};
  }

  & .ant-checkbox {
    border-color: ${themeColor('darkBlue')};
    border-radius: ${({ theme }) => theme.radius.xsm};
    ${({ $readOnly }) => $readOnly && `opacity: 0.6;`}
  }

  &&& .ant-checkbox.ant-checkbox-disabled {
    border-color: ${antdTokens.colorBorderDisabled};
    background-color: ${antdTokens.colorBgContainerDisabled};
  }

  && {
    font-size: ${({ theme }) => theme.fontSizes.md};
    font-weight: ${({ theme }) => theme.fontWeights.regular};
  }

  .ant-checkbox-indeterminate::after {
    background-color: white;
    height: 2px;
    width: 8px;
  }

  .ant-checkbox-indeterminate,
  .ant-checkbox-indeterminate:not(.ant-checkbox-disabled):hover {
    background-color: ${themeColor('darkBlue')};
  }
`;

export const Checkbox = styled(ANTDCheckbox)<{ $readOnly?: boolean }>`
  ${checkboxStyle}
`;
